module.exports = __webpack_public_path__ + "static/media/farm-large.c1fe91bd.webp";